<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input
                v-model="searchForm.username"
                placeholder="用户名"
                clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.email"
          placeholder="邮箱"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.phone"
          placeholder="手机号"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.state"
          placeholder="账号状态"
          clearable
          style="width: 120px">
          <el-option label="全部" value=""></el-option>
          <el-option label="未激活" :value="0"></el-option>
          <el-option label="已激活" :value="1"></el-option>
          <el-option label="禁用" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.registerMethod"
          placeholder="注册方式"
          clearable
          style="width: 120px">
          <el-option label="全部" value=""></el-option>
          <el-option label="邮箱注册" :value="1"></el-option>
          <el-option label="手机号注册" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.isCoCreationMember"
          placeholder="共创成员"
          clearable
          style="width: 120px">
          <el-option label="全部" value=""></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="userDate"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button @click="getUserList">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            border
            stripe>
      <el-table-column
              prop="name"
              label="用户名"
              width="160"
              show-overflow-tooltip>
      </el-table-column>
      <el-table-column
              prop="email"
              label="邮箱"
              width="200"
              show-overflow-tooltip>
      </el-table-column>
      <el-table-column
              prop="phone"
              label="手机号"
              width="120"
              show-overflow-tooltip>
      </el-table-column>
      <el-table-column
              prop="post"
              label="所属岗位"
              show-overflow-tooltip>
      </el-table-column>
      <el-table-column
              prop="state"
              label="账号状态"
              width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 0" type="info">未激活</el-tag>
          <el-tag v-else-if="scope.row.state == 1" type="success">已激活</el-tag>
          <el-tag v-else-if="scope.row.state == 2" type="danger">禁用</el-tag>
        </template>
      </el-table-column>
			<el-table-column
							prop="registerMethod"
							label="注册方式"
							width="100">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.registerMethod == 1">邮箱注册</el-tag>
					<el-tag v-else-if="scope.row.registerMethod == 2" type="success">手机号注册</el-tag>
				</template>
			</el-table-column>
      <el-table-column
              prop="createTime"
              width="160"
              label="注册时间"
              show-overflow-tooltip>
      </el-table-column>
      <el-table-column
              prop="updateTime"
              width="160"
              label="最后一次登录时间"
              show-overflow-tooltip>
      </el-table-column>
      <el-table-column
              prop="isCoCreationMember"
              label="共创成员"
              width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isCoCreationMember == 1" type="success">是</el-tag>
          <el-tag v-else type="info">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
              label="操作"
              width="200"
              fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.isCoCreationMember == 0"
            size="mini"
            type="success"
            @click="handleUpdateMemberStatus(scope.row, 1)">设为共创成员</el-button>
          <el-button
            v-else
            size="mini"
            type="danger"
            @click="handleUpdateMemberStatus(scope.row, 0)">取消共创成员</el-button>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="page.current"
            :page-size="page.size"
            :total="page.total">
    </el-pagination>
  </div>
</template>

<script>
  export default {
    name: "User",
    data() {
      return {
        userDate: [],
        searchForm: {},
        page: {
          total: 0,
          size: 10,
          current: 1,
        },
        tableData: []
      }
    },
    created() {
      this.getUserList(this.page)
    },
    methods: {
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.page.size = val
        this.getUserList(this.page)
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page.current = val
        this.getUserList(this.page)
      },
      getUserList(page) {
        // 处理下拉框的空值：如果选择"全部"（空字符串、null或undefined），则传null给后端
        const params = {
          name: this.searchForm.username,
          email: this.searchForm.email,
          phone: this.searchForm.phone,
          state: (this.searchForm.state === '' || this.searchForm.state == null) ? null : this.searchForm.state,
          registerMethod: (this.searchForm.registerMethod === '' || this.searchForm.registerMethod == null) ? null : this.searchForm.registerMethod,
          isCoCreationMember: (this.searchForm.isCoCreationMember === '' || this.searchForm.isCoCreationMember == null) ? null : this.searchForm.isCoCreationMember,
          startDate: this.userDate === null ? null : this.userDate[0],
          endDate: this.userDate === null ? null : this.userDate[1],
          current: page == null ? this.page.current : page.current,
          size: page == null ? this.page.size : page.size,
        }
        this.$axios.post("/uxm/user/page", params).then(res => {
          // 防止空指针异常：检查响应数据是否存在
          if (res && res.data && res.data.data) {
            this.tableData = res.data.data.records || []
            this.page.size = res.data.data.size || 10
            this.page.current = res.data.data.current || 1
            this.page.total = res.data.data.total || 0
          } else {
            // 如果响应数据格式不正确，重置为空数据
            this.tableData = []
            this.page.total = 0
          }
        }).catch(error => {
          // 错误处理：显示错误信息并重置数据
          console.error('获取用户列表失败:', error)
          this.tableData = []
          this.page.total = 0
        })
      },
      handleUpdateMemberStatus(row, status) {
        const action = status === 1 ? '设为共创成员' : '取消共创成员'
        this.$confirm(`确定要${action}吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post("/uxm/user/updateCoCreationMemberStatus", null, {
            params: {
              userId: row.id,
              isCoCreationMember: status
            }
          }).then(res => {
            if (res && res.data && res.data.code === 200) {
              this.$message({
                type: 'success',
                message: `${action}成功`
              })
              // 刷新列表
              this.getUserList()
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg || `${action}失败`
              })
            }
          }).catch(error => {
            console.error('更新共创成员状态失败:', error)
            this.$message({
              type: 'error',
              message: `${action}失败，请稍后重试`
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    }
  }
</script>

<style scoped>
  .el-pagination {
    float: right;
    margin-top: 22px;
  }

  /* 表格文本不换行，超出部分显示省略号 */
  .el-table .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
